/**
 * @param {string} email
 */

function validateEmail(email) {
  if (!email) {
    return "Email is required.";
  }

  // Basic, practical email regex (RFC-compliant enough for most apps)
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(email)) {
    return "Please enter a valid email address.";
  }

  return null; // valid
}

/**
 * @param {boolean} consent
 */
function validateConsent(consent) {
  if (!consent) {
    return "You must consent before subscribing.";
  }

  return null; // valid
}

/**
 * @param {HTMLInputElement} input
 * @param {string|null} error
 */
function setFieldError(input, error) {
  const field = input.closest('.form-group');
  const errorEl = field ? field.querySelector('.err-msg') : null;

  if (error) {
    input.classList.add('invalid-input');
    if (errorEl) {
      errorEl.textContent = error;
    } else {
      console.warn('Error element not found');
    }
  } else {
    input.classList.remove('invalid-input');
    if (errorEl) {
      errorEl.textContent = '';
    } else {
      console.warn('Error element not found');
    }
  }
}
